import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { PrivilegesService } from '@shared/privileges/privileges.service';

export const adminRouteGuard: CanMatchFn = () => {
  const privilegesService = inject(PrivilegesService);
  return privilegesService.isCurrentUserAdmin();
};

export const privilegesAdminRouteGuard: CanMatchFn = () => {
  const privilegesService = inject(PrivilegesService);
  return privilegesService.isCurrentUserPrivilegeUser();
};

export const categoryAdminRouteGuard: CanMatchFn = () => {
  const privilegesService = inject(PrivilegesService);
  return privilegesService.isCurrentUserCategoryUser();
};

export const tagAdminRouteGuard: CanMatchFn = () => {
  const privilegesService = inject(PrivilegesService);
  return privilegesService.isCurrentUserTagUser();
};
